import script from "./Signup.vue?vue&type=script&setup=true&lang=ts"
export * from "./Signup.vue?vue&type=script&setup=true&lang=ts"

import "./Signup.vue?vue&type=style&index=0&id=6ce8ffe5&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ce8ffe5"]])

export default __exports__